import { createContext } from 'react';

export const FieldContext = createContext(new Map());
